/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { PwcAiChatController } from '../controller/pwc-ai-chat-controller.js';
import { PwcAiChatHttpClient } from '../client/pwc-ai-chat-http-client.js';
import { DefaultSettings } from '../default-settings.js';
/**
 * Represents a builder for creating a chat controller.
 */
export class PwcAiChatControllerBuilder {
    /**
     * Set the authentication token.
     */
    withAuthenticationToken(authenticationToken) {
        this._authenticationToken = authenticationToken;
        return this;
    }
    /**
     * Set the client instance to use.
     */
    withClient(pwcAiChatClientInstance) {
        this._clientInstance = pwcAiChatClientInstance;
        return this;
    }
    /**
     * Set the endpoint to use.
     */
    withHttpEndpoint(httpEndpoint) {
        this._httpEndpoint = httpEndpoint;
        return this;
    }
    /**
     * Set the flowToken to use.
     */
    withFlowToken(flowToken) {
        this._flowToken = flowToken;
        return this;
    }
    /**
     * Set the polling settings.
     */
    withPollingSettings(pollingSettings) {
        this._pollingSettings = pollingSettings;
        return this;
    }
    /**
     * Build a PwcAiChatController.
     */
    build() {
        // validate inputs (client).
        let clientInstance = this._clientInstance;
        if (!clientInstance) {
            // an authentication token should be provided.
            if (!this._authenticationToken) {
                throw new Error('No authentication token provided.');
            }
            // validate inputs (endpoint).
            let httpEndpoint = DefaultSettings.HTTP_ENDPOINT;
            if (this._httpEndpoint) {
                httpEndpoint = this._httpEndpoint;
            }
            // create the HTTP client instance.
            clientInstance = new PwcAiChatHttpClient(this._authenticationToken, httpEndpoint, this._flowToken);
        }
        // set polling settings.
        let pollingSettings = DefaultSettings.POLLING_SETTINGS;
        if (this._pollingSettings) {
            pollingSettings = this._pollingSettings;
        }
        // create a new instance of the controller.
        return new PwcAiChatController(clientInstance, pollingSettings);
    }
}
//# sourceMappingURL=pwc-ai-chat-controller-builder.js.map